    class FeatureChart extends HTMLElement {
        connectedCallback() {
          this.viewButtonElement = this.querySelector('[data-action="toggle-rows"]');
          this.featureChartTable = this.querySelector(".feature-chart__table");
          this.featureChartRows = Array.from(this.featureChartTable.querySelectorAll(".feature-chart__table-row"));
          this.featureChartSticky = this.querySelector(".feature-chart__table-row--sticky");
          this.featureProductRow = this.querySelector(".feature-chart__table-row--product");
      
          if (this.viewButtonElement) {
            this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this));
          }
        }
      
        _toggleRows() {
          if (this.classList.contains("is-expanded")) {
            this._hideRows();
          } else {
            this._showRows();
          }
        }
      
        async _showRows() {
          const maxRows = parseInt(this.getAttribute("max-rows")) || 0;
          const viewMoreText = this.viewButtonElement.querySelector(".feature-chart__toggle-text");
          this.classList.add("is-expanded");
      
          // Show all rows after the max rows, animating them in
          this.featureChartRows.forEach((row, index) => {
            if (index >= maxRows) {
              row.classList.add("feature-chart__table-row--expanded");
              row.classList.remove("feature-chart__table-row--collapsed");
              row.hidden = false;
            }
          });
      
          viewMoreText.innerText = this.viewButtonElement.getAttribute("data-view-less");
      
          // Animate chevron flip
          const chevronIcon = this.viewButtonElement.querySelector(".circle-chevron");
          if (chevronIcon) {
            chevronIcon.classList.add("feature-chart__toggle-icon--flipped");
          }
        }
      
        async _hideRows() {
          const maxRows = parseInt(this.getAttribute("max-rows")) || 0;
          const viewMoreText = this.viewButtonElement.querySelector(".feature-chart__toggle-text");
          this.classList.remove("is-expanded");
      
          // Hide rows after the max rows, animating them out
          let totalHeight = 0;
          this.featureChartRows.forEach((row, index) => {
            if (index >= maxRows) {
              totalHeight += row.clientHeight;
              row.classList.add("feature-chart__table-row--collapsed");
              row.classList.remove("feature-chart__table-row--expanded");
              row.hidden = true;
            }
          });
      
          viewMoreText.innerText = this.viewButtonElement.getAttribute("data-view-more");
      
          // Animate chevron flip back
          const chevronIcon = this.viewButtonElement.querySelector(".circle-chevron");
          if (chevronIcon) {
            chevronIcon.classList.remove("feature-chart__toggle-icon--flipped");
          }
        }
      }
      
      window.customElements.get("feature-chart") || window.customElements.define("feature-chart", FeatureChart);
      
class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    console.log('[CollectionTabs] Constructor called for section:', this.dataset.sectionId);
  }

  connectedCallback() {
    console.log('[CollectionTabs] Connected to DOM, initializing for section:', this.dataset.sectionId);
    
    this.tabButtons = this.querySelectorAll('.collection-tab__button');
    this.tabContents = this.querySelectorAll('.collection-tab__content');
    
    console.log('[CollectionTabs] Found tab buttons:', this.tabButtons.length);
    console.log('[CollectionTabs] Found tab contents:', this.tabContents.length);
    
    if (!this.tabButtons.length) {
      console.warn('[CollectionTabs] No tab buttons found, component not initialized');
      return;
    }
    
    this.init();
  }

  init() {
    console.log('[CollectionTabs] Binding click events to tabs');
    
    this.tabButtons.forEach((button, index) => {
      console.log(`[CollectionTabs] Setting up button ${index + 1}:`, button.textContent.trim(), 'Target:', button.dataset.target);
      
      button.addEventListener('click', (event) => {
        console.log(`[CollectionTabs] Button clicked:`, button.textContent.trim());
        this.handleTabClick(event);
      });
    });
  }

  handleTabClick(event) {
    const clickedButton = event.currentTarget;
    const targetId = clickedButton.dataset.target;
    
    console.log('[CollectionTabs] Tab clicked:', clickedButton.textContent.trim());
    console.log('[CollectionTabs] Target ID:', targetId);
    
    const targetElement = this.querySelector(`#${targetId}`);
    if (!targetElement) {
      console.error(`[CollectionTabs] Target element #${targetId} not found!`);
      return;
    }
    
    console.log('[CollectionTabs] Found target element:', targetElement.id);
    
    // Remove active class from all buttons and contents
    this.tabButtons.forEach(btn => btn.classList.remove('is-active'));
    this.tabContents.forEach(content => content.classList.remove('is-active'));
    
    // Add active class to clicked button and its content
    clickedButton.classList.add('is-active');
    targetElement.classList.add('is-active');
    
    console.log('[CollectionTabs] Active button:', clickedButton.textContent.trim());
    console.log('[CollectionTabs] Active content:', targetElement.id);
    
    // Reinitialize sliders if needed
    const activeSlider = targetElement.querySelector('slider-component');
    if (activeSlider) {
      console.log('[CollectionTabs] Refreshing slider component');
      window.dispatchEvent(new Event('resize'));
    }
  }
}

customElements.define('collection-tabs', CollectionTabs);